<div class="it-kv">
	<div class="it-kvhead">
		<div>Key</div>
		<div>Value</div>
		<div></div>
	</div>

	<div class="it-kvrow" *ngFor="let row of rows; let i = index">
		<input class="it-kvinput" type="text" [value]="row.key" (input)="updateKv.emit({ index: i, patch: { key: $any($event.target).value } })" />
		<input class="it-kvinput" type="text" [value]="row.value" (input)="updateKv.emit({ index: i, patch: { value: $any($event.target).value } })" />
		<button class="it-mini danger" type="button" (click)="remove.emit({ index: i })">Remove</button>
	</div>
</div>
